import React from "react";
import PropTypes from "prop-types";

const Footer = (props) => {
    return (
        <div className={`pt-4 ft py-3 bg-${props.mode}`}>
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <h5 className={`text-${props.mode === 'light' ? 'dark' : 'white'}`}>Design By Waleed Ishfaq</h5>
                    </div>
                    <div className="col-md-5">
                        <h5 className={`text-${props.mode === 'light' ? 'dark' : 'white'}`}>
                            @ Copyright 2023 Waleedcodes. All rights reserved
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
};

Footer.propTypes = {
    title: PropTypes.string.isRequired,
};
export default Footer;
